import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { IntegrationsMenu } from "./IntegrationsMenu";
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { Link, useNavigate } from "react-router-dom";
import oilGasLogo from "@/assets/oil-gas-logo.svg";

export const OilGasHeader = () => {
  const navigate = useNavigate();

  const handleCfKClick = () => {
    navigate("/chevron-call-for-knowledge");
  };

  const handleCfSClick = () => {
    navigate("/chevron/call-for-solutions");
  };

  const handleCfDClick = () => {
    navigate("/chevron/call-for-destruction");
  };
  return (
    <div className="flex items-center gap-6 justify-between">
      <div className="flex items-center gap-6">
        <img 
          src={oilGasLogo} 
          alt="Oil and Gas Logo" 
          className="w-24 h-24 object-contain"
        />
        <div>
          <CardTitle className="text-2xl font-bold mb-2">Oil and Gas</CardTitle>
          <CardDescription className="text-lg">
            Explore oil and gas knowledge domains and contribute to our collective intelligence
          </CardDescription>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button 
                className="bg-black text-white hover:bg-primary transition-colors"
                onClick={handleCfKClick}
              >
                CfK
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Call for Knowledge (demo)</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>

        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button 
                className="bg-black text-white hover:bg-primary transition-colors"
                onClick={handleCfSClick}
              >
                CfS
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Call for Solutions (demo)</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>

        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button 
                className="bg-black text-white hover:bg-primary transition-colors"
                onClick={handleCfDClick}
              >
                CfD
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Call for Destruction (demo)</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>

        <IntegrationsMenu />
      </div>
    </div>
  );
};
